/**
 * usePrerenderSafe — react-snap safety primitives for CCPlayer.
 * Design doc: agent_docs/cel1157_tutorials_hub_design.md §5.
 *
 * IS_PRERENDER: true while react-snap's puppeteer crawls the page (ReactSnap UA).
 * The prerendered snapshot must never contain an ARMED (src'd) autoplay video,
 * and any <video> serialized into static HTML must carry a REAL `muted`
 * attribute: React sets `muted` only as a DOM property and never serializes
 * the attribute, so a snapshot taken without it could autoplay WITH SOUND
 * during the pre-React window after a hard refresh (the HomeHeroVideo lesson,
 * Aug 2026). Theater is click-to-play (no autoplay attr), so the attribute is
 * belt-and-suspenders there; Ambient (phase C) depends on it.
 */
export const IS_PRERENDER =
  typeof navigator !== 'undefined' && navigator.userAgent.includes('ReactSnap');

/**
 * Returns a ref-callback that (a) forwards the element to `videoRef`
 * (object ref or function ref) and (b) when `mutedAttr` is true, serializes a
 * real `muted` attribute onto the element so any static snapshot of it is
 * genuinely muted.
 */
export const makeVideoRefAttacher = (videoRef, { mutedAttr = false } = {}) => (el) => {
  if (typeof videoRef === 'function') videoRef(el);
  else if (videoRef) videoRef.current = el;
  if (el && mutedAttr && !el.hasAttribute('muted')) el.setAttribute('muted', '');
};
